import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/DeviationDescription/config';
import cn from 'classnames';
import s from './DeviationDescription.scss';
const DeviationDescriptionViewer = ({ contentJson, className, externalRenderers, cookieType, defaultSize })=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "deviation-description",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize
    });
};
DeviationDescriptionViewer.displayName = 'DeviationDescriptionViewer';
export default DeviationDescriptionViewer;

//# sourceMappingURL=DeviationDescription.js.map